import camelcase from 'camelcase-web'
import Less from '!less-var-to-js-loader!./theme.less'

const theme = {}
Object.keys(Less).forEach(k => theme[camelcase(k)] = Less[k])

export { theme }

export default {
	data(){
		return {
			theme
		}
	}
}